<template>
  <div class="VmpAIChatBotList">
    <div class="tools">
      <vh-input
        round
        class="search"
        :placeholder="$t('host.k_627001')"
        v-model="keyword"
        clearable
        size="medium"
        @clear="initQueryUserList"
        @keyup.enter.native="initQueryUserList"
      >
        <i class="vh-icon-search vh-input__icon" slot="prefix" @click="initQueryUserList"></i>
      </vh-input>
    </div>
    <div class="list">
      <!-- 表格与分页 -->
      <vh-table
        ref="tableList"
        :data="tableList || []"
        :height="360"
        :header-cell-style="{
          color: '#666',
          height: '56px'
        }"
      >
        <vh-table-column :label="$t('host.k_627002')" width="80">
          <template slot-scope="scope">
            <div class="flexBox">
              <div class="gift-cover">
                <img :src="scope.row.avatar" alt="" v-parseImgOss="{ url: scope.row.avatar }" />
              </div>
            </div>
          </template>
        </vh-table-column>
        <vh-table-column :label="$t('host.k_627003')" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.nickname }}</span>
          </template>
        </vh-table-column>
        <vh-table-column :label="$t('host.k_627004')" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.chat_content }}
          </template>
        </vh-table-column>
        <vh-table-column :label="$t('host.k_627005')" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.content_title }}
          </template>
        </vh-table-column>
        <vh-table-column :label="$t('host.k_627006')" width="120">
          <template slot-scope="scope">
            <div class="itemStatus">
              <div class="prefix" :class="'prefix' + scope.row.status"></div>
              <div>{{ statusGroup[scope.row.status] }}</div>
            </div>
          </template>
        </vh-table-column>
        <vh-table-column :label="$t('host.k_627007')" align="left" width="100px">
          <template slot-scope="scope">
            <vh-button type="text" @click="startTopic(scope.row)">
              {{ $t('host.k_627008') }}
            </vh-button>
          </template>
        </vh-table-column>
        <div class="" slot="empty">
          <NullMode class="search-no-data"></NullMode>
        </div>
      </vh-table>
      <div class="pageList" v-if="total > limit">
        <vh-pagination
          background
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :currentPage="pageNumber"
          @current-change="currentChangeHandler"
          @size-change="handleSizeChange"
        ></vh-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import { useRoomBaseServer, useChatServer, useMsgServer } from 'middle-domain';
  import NullMode from '@/packages/null-mode';

  export default {
    name: 'VmpAIChatBotList', // 发起端AI虚拟观众列表弹窗
    components: {
      NullMode
    },
    data() {
      return {
        total: 0,
        pos: 0,
        pageNumber: 1,
        limit: 20,
        keyword: '',
        statusGroup: [
          this.$t('host.k_627009'),
          this.$t('host.k_627010'),
          this.$t('host.k_627011'),
          this.$t('host.k_627012')
        ],
        tableList: []
      };
    },
    beforeCreate() {
      this.roomBaseServer = useRoomBaseServer();
      this.chatServer = useChatServer();
    },
    async created() {
      const msgServer = useMsgServer();
      msgServer.$onMsg('ROOM_MSG', msg => {
        // console.log(msg);
        if (
          msg &&
          msg.data &&
          msg.data.type == 'chatbot_status_notice' &&
          msg.data.scene_type == 'virtual_audience'
        ) {
          for (let index = 0; index < this.tableList.length; index++) {
            if (this.tableList[index].id == msg.data.id) {
              this.tableList[index].status = msg.data.status;
              break;
            }
          }
        }
      });
    },
    methods: {
      initComponent() {
        this.initQueryUserList();
      },
      initQueryUserList() {
        this.pos = 0;
        this.pageNumber = 1;
        this.limit = 20;
        // 表格切换到第一页
        this.$nextTick(() => {
          if (this.$refs.tableList && this.$refs.tableList.pageInfo) {
            this.$refs.tableList.pageInfo.pageNum = 1;
            this.$refs.tableList.pageInfo.pos = 0;
          }
          this.getVirtualTbList();
        });
      },
      getVirtualTbList(row) {
        if (row) {
          this.pos = row.pos;
          this.pageNumber = row.pageNum;
        }
        // this.loading = true;
        let params = {
          keyword: this.keyword,
          pos: this.pos,
          limit: this.limit
        };
        this.chatServer.getVirtualList(params).then(res => {
          this.total = res.data.total;
          this.tableList = res.data.list;
        });
      },
      startTopic(row) {
        if (this.roomBaseServer.state.watchInitData.webinar.type == 1) {
          this.chatServer
            .pushMessage({
              chatbot_id: row.id
            })
            .then(res => {
              this.getVirtualTbList();
            });
        } else {
          this.$message({
            message: this.$t('host.k_627013'),
            showClose: true,
            type: 'error',
            customClass: 'zdy-info-box'
          });
        }
      },
      // 页码改变按钮事件
      currentChangeHandler(current) {
        this.pageNumber = current;
        this.pos = parseInt((current - 1) * this.limit);
        this.getVirtualTbList();
      },
      // 每页显示个数选择器的选项设置 改变按钮事件
      handleSizeChange(current) {
        this.pageNumber = 1;
        this.limit = current;
        this.pos = parseInt((this.pageNumber - 1) * this.limit);
        this.getVirtualTbList();
      }
    }
  };
</script>
<style lang="less">
  .VmpAIChatBotList {
    .tools {
      margin-bottom: 16px;
      overflow: hidden;
      .search {
        float: right;
        width: 320px;
        height: 36px;
        .vh-input__inner {
          height: 36px;
          .vh-input__icon {
            line-height: 36px;
          }
        }
      }
    }
    .list {
      color: #1a1a1a;
      .vh-table {
        margin-bottom: 24px;
        .itemStatus {
          display: flex;
          align-items: center;
          .prefix {
            width: 6px;
            height: 6px;
            min-width: 6px;
            border-radius: 50%;
            margin-right: 4px;
            &.prefix0 {
              background-color: #fc9600;
            }
            &.prefix1 {
              background-color: #0fba5a;
            }
            &.prefix2 {
              background-color: #0a7ff5;
            }
          }
        }
      }
    }

    .pageList {
      text-align: center;
    }

    .flexBox {
      display: flex;
      align-items: center;
      .name {
        margin-left: 10px;
      }
      .gift-cover {
        display: inline-block;
        width: 40px;
        min-width: 40px;
        height: 40px;
        // margin: 3px 0;
        background: #ffffff;
        border-radius: 50%;
        // border-radius: 4px;
        // border: 1px solid #e6e6e6;
        img {
          width: 100%;
          height: 100%;
          object-fit: scale-down;
          border-radius: 50%;
        }
      }
    }
  }
</style>
